import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { roles } from 'cross-platform/utils/roleProps';

import { Range, Value, Wrapper } from './styled';

export interface ProgressBarProps {
  max: number;
  min?: number;
  value: number;
  style?: {
    width?: ViewStyle['width'];
    height?: ViewStyle['height'];
    borderRadius?: ViewStyle['borderRadius'];
    marginTop?: ViewStyle['marginTop'];
    marginBottom?: ViewStyle['marginBottom'];
  } & StyleProp<ViewStyle>;
}

const ProgressBar = ({
  max,
  min = 0,
  value,
  style = {},
}: ProgressBarProps): React.ReactElement => {
  const { width, height, borderRadius, marginTop, marginBottom } = style;
  return (
    <Wrapper
      {...roles('ProgressBar', {
        progressBar: { min, max, value: `${value}` },
      })}
      role="meter"
      aria-label="Player progress"
      style={{ width, marginTop, marginBottom }}
    >
      <Range style={{ height, borderRadius }} />
      <Value
        min={min}
        max={max}
        value={value}
        style={{ height, borderRadius }}
      />
    </Wrapper>
  );
};

export { ProgressBar };
